(function () {
  'use strict';
  if (window.LOA_FOUR_EXPERIMENT) return;
  var EXP = 'ebl-four-volumes-20260909', KEY = 'loa_four_assignment_v1';
  var q = new URLSearchParams(location.search), qa = q.get('utm_source') === 'internal_qa';
  var A = [57784731337052,57784731369820,57784731402588,57784731435356,58083673506140,58083673571676,58083673604444];
  var B = [59064616583516,59064616616284,59064616649052,59064616681820,59064616714588];
  var route = {
    presell: {A:'/pages/5-reasons-ethiopian-bible',B:'/pages/6-reasons-ethiopian-bible-four-volumes'},
    direct: {A:'/products/ethiopian-bible-library?view=ethbible-b',B:'/products/ethiopian-bible-library-four-volumes?view=ethbible-four-b'}
  };
  var entry = document.querySelector('[data-loa-experiment-entry]');
  var assignment = null, seen = new Set(), viewSent = false;
  try { assignment = JSON.parse(localStorage.getItem(KEY)); } catch (_) {}
  if (!assignment || assignment.experiment !== EXP || !/^[AB]$/.test(assignment.arm) ||
      !/^[a-f0-9]{32}$/.test(assignment.visitor || '') || Date.now()-assignment.created > 90*86400000) assignment = null;
  if (!assignment && (entry || q.get('loa_exp') === EXP)) {
    var bytes = new Uint8Array(16); crypto.getRandomValues(bytes);
    var arm = /^[AB]$/.test(q.get('loa_arm') || '') ? q.get('loa_arm') : (bytes[0] < 128 ? 'A' : 'B');
    var visitor = /^[a-f0-9]{32}$/.test(q.get('loa_visitor') || '') ? q.get('loa_visitor') : Array.from(bytes,function(n){return n.toString(16).padStart(2,'0');}).join('');
    assignment = {experiment:EXP,arm:arm,visitor:visitor,created:Date.now(),path:(entry && entry.dataset.loaExperimentEntry) || (q.get('loa_path') === 'presell' ? 'presell' : 'direct')};
  }
  if (assignment && !qa) {
    try { localStorage.setItem(KEY,JSON.stringify(assignment)); document.cookie='loa_four_experiment=1; Max-Age=7776000; Path=/; SameSite=Lax; Secure'; } catch (_) {}
  }
  function transport(url) {
    var u = new URL(url,location.origin);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','gclid','gbraid','wbraid','msclkid','ttclid'].forEach(function(k){var v=q.get(k);if(v && v.length <= 1024)u.searchParams.set(k,v);});
    if (assignment) {
      u.searchParams.set('loa_exp',EXP); u.searchParams.set('loa_arm',assignment.arm);
      u.searchParams.set('loa_visitor',assignment.visitor); u.searchParams.set('loa_path',assignment.path);
    }
    return u.href;
  }
  if (entry && assignment) { location.replace(transport(route[assignment.path][assignment.arm])); return; }
  var surfaceB = location.pathname.indexOf('four-volumes') > -1;
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !qa && !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
  }
  function mailAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return allowed() && !!(privacy.marketingAllowed && privacy.marketingAllowed());
  }
  function measureAssignment() {
    if (!assignment || !allowed() || seen.has('assignment-measurement')) return;
    var receipt=EXP+':measured:'+assignment.visitor;
    try { if(localStorage.getItem(receipt))return; } catch (_) {}
    seen.add('assignment-measurement');
    function send(){
      // Event names encode the arm, so GA4 reports do not require a new custom
      // dimension. Send once per assignment, across sessions and funnel stages.
      window.gtag('event','loa_four_assigned_'+assignment.arm.toLowerCase(),{
        send_to:'G-VMGSG4T4SQ',experiment:EXP,assignment_id:assignment.visitor,
        original_arm:assignment.arm,entry_path:assignment.path,
        page_location:transport(location.href || location.origin+location.pathname),
        event_callback:function(){try{localStorage.setItem(receipt,'1');}catch(_){}}
      });
    }
    if(typeof window.gtag==='function'){send();return;}
    window.dataLayer=window.dataLayer || [];
    window.gtag=function(){window.dataLayer.push(arguments);};
    window.gtag('js',new Date());
    // Shopify Customer Events retains the existing page-view/purchase path.
    window.gtag('config','G-VMGSG4T4SQ',{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false});
    var tag=document.createElement('script');tag.async=true;
    tag.src='https://www.googletagmanager.com/gtag/js?id=G-VMGSG4T4SQ';
    tag.onload=send;tag.onerror=function(){seen.delete('assignment-measurement');};
    document.head.appendChild(tag);
  }
  function cart(cartData) {
    if (!assignment || qa) return;
    var ids = ((cartData && cartData.items) || []).map(function(i){return Number(i.variant_id);});
    var hasA = ids.some(function(id){return A.indexOf(id)>-1;}), hasB = ids.some(function(id){return B.indexOf(id)>-1;});
    var attrs = window.__LOA_FB_ATTRS = window.__LOA_FB_ATTRS || {};
    attrs.loa_experiment=EXP; attrs.loa_original_arm=assignment.arm; attrs.loa_assignment_id=assignment.visitor;
    attrs.loa_analytics_consent=allowed()?'true':'false';
    try{attrs.loa_assignment_measured=localStorage.getItem(EXP+':measured:'+assignment.visitor)?'true':'false';}catch(_){attrs.loa_assignment_measured='false';}
    attrs.loa_entry_path=assignment.path; attrs.loa_assigned_at=String(assignment.created);
    attrs.loa_mixed_family_cart=hasA && hasB ? 'true' : 'false';
    attrs.loa_observed_offer=hasA && hasB ? 'mixed' : hasB ? 'four_volumes' : hasA ? 'five_volumes' : surfaceB ? 'four_volumes' : 'five_volumes';
  }
  function hookWriter() {
    if (!assignment && !surfaceB) return;
    var owner=window.EBCartV2 || window.EnochCartV2;
    if (!owner || owner.__fourExperiment) return;
    owner.__fourExperiment=true;
    var replace=owner.replace;
    owner.replace=function(items,keep){
      return owner.resumeFromHistory().then(function(){
        var current=owner.state().confirmed, next=Object.assign({},keep || {}), family=surfaceB ? B.slice(0,4).concat(A) : A.slice(0,4);
        /* A new four-volume selection replaces the previous five-volume offer in the same write.
           Explicit standalone extras and an already chosen four-volume checkout gift remain. */
        ((current && current.items) || []).forEach(function(line){if(family.indexOf(Number(line.variant_id))===-1 && Number(line.final_line_price)>0)next[line.variant_id]=line.quantity;});
        cart(current); return replace(items,next);
      });
    };
    var checkout=owner.beginCheckout;
    owner.beginCheckout=function(){cart(owner.state().confirmed);return checkout.apply(owner,arguments);};
    cart(owner.state().confirmed);
  }
  function ready() {
    hookWriter(); cart(null);
    measureAssignment();
    document.querySelectorAll('a[href]').forEach(function(a){
      var u=new URL(a.href,location.origin);
      if(u.origin===location.origin && /(?:5-reasons-ethiopian-bible|6-reasons-ethiopian-bible-four-volumes|products\/ethiopian-bible-library)/.test(u.pathname))a.href=transport(u.href);
    });
    if (assignment && allowed() && !seen.has('exposure')) {
      var key=EXP+':'+assignment.visitor+':'+assignment.path+':'+(surfaceB?'B':'A');
      try {
        var sent=sessionStorage.getItem(key);
        if(!sent && window.Shopify.analytics && window.Shopify.analytics.publish){
          window.Shopify.analytics.publish('loa:four_volume_exposure',{experiment:EXP,assignment_id:assignment.visitor,original_arm:assignment.arm,observed_arm:surfaceB?'B':'A',entry_path:assignment.path});
          sessionStorage.setItem(key,'1');
        }
      } catch (_) {}
      seen.add('exposure');
    }
    if (!viewSent && surfaceB && mailAllowed() && window.__LOA_FOUR_PRODUCT__) {
      var p=Object.assign({},window.__LOA_FOUR_PRODUCT__); p.URL=transport(p.URL);
      window._learnq=window._learnq || []; window._learnq.push(['track','Viewed Product',p]);
      window._learnq.push(['trackViewedItem',{Title:p.Name,ItemId:p.ProductID,Url:p.URL,ImageUrl:p.ImageURL,Metadata:{Brand:p.Brand,Price:p.Price}}]);
      viewSent=true;
    }
  }
  window.LOA_FOUR_EXPERIMENT={cart:cart,assignment:assignment,transport:transport};
  window.LOA_FOUR_ATC={track:function(payload){
    if(!mailAllowed() || !payload || payload.offer_family!=='ebl-4v' || seen.has(payload.event_id))return {sent:0};
    var lines=(payload.lines || []).filter(function(line){return B.indexOf(Number(line.variant_id))>-1 && line.quantity>0 && line.item_price>0;});
    if(!lines.length)return {sent:0};
    var url=transport('/products/ethiopian-bible-library-four-volumes?view=ethbible-four-b&loa_resume=1');
    var main=lines.find(function(line){return B.slice(0,4).indexOf(Number(line.variant_id))>-1;});
    if(main)url+='&loa_pack='+main.variant_id;
    var properties={OfferFamily:'ebl-4v',Source:'four_volume_verified_cart_write',URL:url,Items:lines.map(function(line){return line.product_title;}),ProductID:'15810508849500',Currency:payload.currency,'$currency':payload.currency,'$value':lines.reduce(function(v,line){return v+line.quantity*line.item_price;},0),PaidLines:lines,EventID:payload.event_id};
    window._learnq=window._learnq || []; window._learnq.push(['track','Four-Volume Paid Cart Added',properties]);
    seen.add(payload.event_id); return {sent:1};
  }};
  document.addEventListener('eb:cart-assets-ready',ready);
  document.addEventListener('visitorConsentCollected',ready);
  document.addEventListener('customerPrivacyApiLoaded',ready);
  window.addEventListener('load',ready,{once:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
  if(window.Shopify && window.Shopify.loadFeatures && !window.Shopify.customerPrivacy){
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)ready();});
  }
})();
